export default __webpack_public_path__ + "static/icon_simple.cc8334780027777b228e17989d1329b4.png";